import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactGA from 'react-ga';
import Ink from 'react-ink';

import clustering from 'density-clustering'

import ResponsiveImage from '../helpers/responsiveImage/ResponsiveImage';
import { isFullScreenAvailable, getWindowScrollTop, getOffsetRect } from '../helpers';
import * as AppActions from '../app/AppActions';
import * as FloorplanActions from './FloorplanActions';
import MarkerComponent from './MarkerComponent';
import FloorplanComponent from './FloorplanComponent';
import GalleryBottomComponent from './gallery/GalleryBottomComponent';

import './Style';

import fullscreenImg from '../assets/img/fullscreenGray.svg';
import exitFullscreenImg from '../assets/img/exitFullscreenGray.svg';

class FloorplanContainer extends Component {
    constructor(props) {
        super(props);

        this.draggableOnStop = this.draggableOnStop.bind(this);
        this.setActiveImage = this.setActiveImage.bind(this);
        this.changeStageHandler = this.changeStageHandler.bind(this);
        this.galleryAfterChange = this.galleryAfterChange.bind(this);
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.fullscreenBtnClick = this.fullscreenBtnClick.bind(this);
        this.escHandler = this.escHandler.bind(this);
        this.windowOnResize = this.windowOnResize.bind(this);
        this.windowOnScroll = this.windowOnScroll.bind(this);

        this.state = {
            notAvailableHeight: 0.167,
            notAvailableWidth: 0.2,
            orientation: window.innerWidth < window.innerHeight
                ? 'portrait'
                : 'landscape',
            // orientation: 'portrait',
            clusterZoom: false,
            stepClusterZoom: 0,
            zoomEmount: 0,
            containerRef: {}
        }
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.windowOnResize, false);
        window.addEventListener('scroll', this.windowOnScroll, false);
        window.addEventListener('fullscreenchange', this.escHandler, false);
        window.addEventListener('webkitfullscreenchange', this.escHandler, false);
        window.addEventListener('mozfullscreenchange', this.escHandler, false);
        window.addEventListener('MSFullscreenChange', this.escHandler, false);
        this.setState({
            containerRef: this.container
        })
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.windowOnResize, false);
        window.removeEventListener('scroll', this.windowOnScroll, false);
        window.removeEventListener('fullscreenchange', this.escHandler, false);
        window.removeEventListener('webkitfullscreenchange', this.escHandler, false);
        window.removeEventListener('mozfullscreenchange', this.escHandler, false);
        window.removeEventListener('MSFullscreenChange', this.escHandler, false);
    }

    windowOnResize() {
        this.setState({
            orientation: window.innerWidth < window.innerHeight
                ? 'portrait'
                : 'landscape'
        });
    }

    windowOnScroll() {
        const windowScrollTop = getWindowScrollTop();
        const floorplanOffsetTop = getOffsetRect(this.container).top;
        const viewportHeight = document.documentElement.clientHeight;

        if (windowScrollTop - floorplanOffsetTop + viewportHeight > 0) {
            if (!this.props.autohideTriggered) {
                this.props.floorplanActions.hideGalleryAfterDelay();
            }
        }
    }

    toggleVisibility() {
        const action = this.props.galleryVisible
            ? 'close thumbnails menu'
            : 'open thumbnails menu';
        // ReactGA.event({
        //     category: 'floorplan',
        //     action: action
        // });
        this.props.floorplanActions.toggleVisibility();
    }

    draggableOnStop(e, data) {
        this.props.floorplanActions.setMapPosition(data.x, data.y);
    }


    setActiveImage(name) {
        this.props.floorplanActions.setActiveSlide(name);
    }

    changeStageHandler(option) {
        const { floorplanActions, stages } = this.props;
        const startFrom = stages[option].beginning
            ? stages[option].beginning
            : 0;
        // ReactGA.event({
        //     category: 'floorplan',
        //     action: 'switch floor'
        // });
        floorplanActions.changeStage(option);
        floorplanActions.setActiveSlide(
            stages[option].markers.length
                ? stages[option].markers[startFrom].file_name
                : ''
        );
    }

    galleryAfterChange(e) {
        this.props.floorplanActions.setActiveSlide(
            this.props.stages[this.props.activeStage].markers[e].file_name
        );
    }

    fullscreenBtnClick() {
        this.props.appActions.toggleFullscreen('floorplan-container');
    }

    escHandler() {
        if (this.props.isFullscreen
            && !document.fullscreenElement
            && !document.webkitIsFullScreen
            && !document.mozFullScreen
            && !document.msFullscreenElement) {
                this.props.appActions.toggleFullscreen('floorplan-container');
        }
    }

    render() {
        const {
            activeStage,
            stages,
            imagesPath,
            imageSizeParams,
            activeSlideName,
            galleryVisible,
            isFullscreen
        } = this.props;

        const stageOptions = stages.map((stage, i) => {
            return { value: i, label: stage.name };
        });

        const galleryBottomBlock = stages[activeStage].markers.length
            ? (
                <GalleryBottomComponent
                    className="gallery-secondary"
                    activeSlideName={activeSlideName}
                    imagesPath={imagesPath}
                    images={stages[activeStage].markers}
                    imageSizeParams={imageSizeParams}
                    galleryVisible={galleryVisible}
                    toggleVisibility={this.toggleVisibility}
                    galleryAfterChange={this.galleryAfterChange}/>
            )
            : null;

        const stagesBlock = stages.length > 2
            ? (
                <div className="stages">
                    <label>Levels</label>
                    <Select
                        clearable={false}
                        searchable={false}
                        readonly="true"
                        value={activeStage}
                        options={stageOptions}
                        onChange={(option) => {
                            if (activeStage !== option.value) {
                                this.changeStageHandler(option.value)
                            }
                        }}
                    />
                </div>
            )
            : stages.length === 2
                ? (
                    <div className="stages btns">
                        <button
                            className={`btn ${activeStage === 0 ? 'disabled' : ''}`}
                            onClick={() => {
                                if (activeStage === 1) {
                                    this.changeStageHandler(0)
                                }
                            }}>
                            {stages[0].name}
                        </button>
                        <button
                            className={`btn ${activeStage === 1 ? 'disabled' : ''}`}
                            onClick={() => {
                                if (activeStage === 0) {
                                    this.changeStageHandler(1)
                                }
                            }}>
                            {stages[1].name}
                        </button>
                    </div>
                )
                : null;

        const fullscreenBtn = isFullScreenAvailable()
            ? (
                <button className="fullscreen btn" onClick={this.fullscreenBtnClick}>
                    <img src={isFullscreen ? exitFullscreenImg : fullscreenImg} alt=""/>
                    <Ink />
                </button>
            )
            : null;

        const getFloorplanClass = () => {
            let floorplanClass = 'floorplan-container';

            if (galleryVisible) {
                floorplanClass = floorplanClass + ' gallery-opened';
            }

            if (!stages[activeStage].markers.length) {
                floorplanClass = floorplanClass + ' no-images';
            }

            if (window.innerWidth < 933) {
                if (window.innerWidth < window.innerHeight) {
                    floorplanClass = floorplanClass + ' portrait';
                } else {
                    floorplanClass = floorplanClass + ' landscape';
                }
            }

            return floorplanClass;
        }

        return (
            <div id="floorplan-container" className={getFloorplanClass()}>
                <div
                    className="floorplan-container-wrapper"
                    ref={(container) => {this.container = container}}>
                    <FloorplanComponent
                        draggableOnStop={this.draggableOnStop}
                        orientation={this.state.orientation}
                        container={this.state.containerRef}
                        />
                        {stagesBlock}
                        {fullscreenBtn}
                </div>
                <div className="mobile-active-image">
                    <div>
                        <ResponsiveImage
                            imagesPath={imagesPath}
                            imageSizeParams={imageSizeParams}
                            filename={activeSlideName}
                            lazyLoad={false}/>
                    </div>
                </div>
                {galleryBottomBlock}
            </div>
        );
    }
}

FloorplanContainer.propTypes = {
    imagesPath: PropTypes.string.isRequired,
    stages: PropTypes.array.isRequired,
    activeStage: PropTypes.number.isRequired,
    activeSlideName: PropTypes.string.isRequired,
    stages: PropTypes.array.isRequired,
    activeStage: PropTypes.number.isRequired,
    galleryVisible: PropTypes.bool.isRequired,
    visitedSlides: PropTypes.object.isRequired,
    autohideTriggered: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
    return {
        imagesPath: state.floorplan.imagesPath,
        stages: state.floorplan.stages,
        activeStage: state.floorplan.activeStage,
        activeSlideName: state.floorplan.activeSlideName,
        galleryVisible: state.floorplan.galleryVisible,
        visitedSlides: state.floorplan.visitedSlides,
        autohideTriggered: state.floorplan.autohideTriggered,
        imageSizeParams: state.gallery.imageSizeParams,
        isFullscreen: state.app.fullscreenEnabled
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        appActions: bindActionCreators(AppActions, dispatch),
        floorplanActions: bindActionCreators(FloorplanActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FloorplanContainer)
